module.exports = __webpack_public_path__ + "img/resized-APP-0017-2.6e05e455.png";